module.exports = __webpack_public_path__ + "static/media/28 - LA Priest - What Moves (Edit).9bc6d2cc.mp3";